import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import element1 from '../../assets/contact-shape-2.png';
import element2 from '../../assets/about-shape2.png';
import element3 from '../../assets/contact-shape-1.png';

import css from './ContactPage.module.css';
import { isLocaleGreek, onSendEmail } from '../../util/genericHelpers';

function SectionHero() {
  return (
    <div className={css.heroContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <span className={css.shape3}>
        <img src={element3} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <div className={css.heroContent}>
          <h1>
            <FormattedMessage id="ContactPage.heading" />
          </h1>
          <p>
            <FormattedMessage id="ContactPage.description" />
          </p>
          {/* <div className={css.registerNowBtn}>
            <button className={css.registerBtn} onClick={onSendEmail}>
              <FormattedMessage id="CompaniesPage.registerButton" />
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default SectionHero;
